import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import AnimationClip from '../AnimationClip';
import Point from '../../../Utility/Point';
import { Random } from '../../../Utility/Random';
import { delay } from '../../../Utility/Task/TaskQueue';

export class LevelScreenShake extends AnimationClip {
    private initialPosition: Point;
    private target: GameObject;
    private targetTransform: TransformComponent;
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        this.target = gameObject;
        this.targetTransform = this.target.getComponent(TransformComponent);

        const frequency = meta.frequency || 50;
        const damping = meta.damping || 0.8;
        let amplitude = meta.amplitude || 5;

        while (amplitude > 0.05) {
            this.targetTransform.position.set(
                amplitude * Random.value(-1, 1),
                amplitude * Random.value(-1, 1)
            );

            amplitude *= damping;

            yield* delay(frequency);
        }

        this.targetTransform.position.set(0, 0);
    }
}
